














import { Vue, Component, Prop, Emit, Model } from 'vue-property-decorator';
import { ICustomStylingClass } from '../types/custom.t';

@Component
export default class CustomCheckbox extends Vue {

  @Prop()
  containerClass?: ICustomStylingClass[];

  @Prop()
  id?: string;

  @Prop()
  name?: string;

  @Prop({ default: false })
  isDisabled!: boolean;

  @Prop({ default: false })
  isChecked!: boolean;
}
